
import { Appconfig } from '@/types/Appconfig'


export default {
    namespaced: true,
    state: <Appconfig>{
            GAID: undefined,
            GAG4: undefined

    },
    
    getters: {
        // eslint-disable-next-line
        // getLoginService: (state:any):string => state.LoginService,
    },
    // mutations: {
    //     // [types.MUTATION](state, value) {
    //     //     state.value = value;
    //     // },
    //     SetLogvalue(state, payload) {
    //         state.LogValue = { ...state.LogValue, payload};
    //     },

    // },
    actions: {}
}